import type { InferRpcDefinition } from "@redotech/rpc/definition";

import { getMe } from "./schema/auth/get-me";
import { impersonationExchange } from "./schema/auth/impersonation-exchange";
import { sendMagicLink } from "./schema/auth/send-magic-link";
import { verifyMagicLink } from "./schema/auth/verify-magic-link";
import { getEarnings } from "./schema/dashboard/get-earnings";
import { getInstalls } from "./schema/dashboard/get-installs";
import { getPayouts } from "./schema/dashboard/get-payouts";

export const rpcDefinition = {
  sendMagicLink,
  verifyMagicLink,
  impersonationExchange,
  getMe,
  getInstalls,
  getPayouts,
  getEarnings,
} as const;

export type ReferralsRpcDefinition = InferRpcDefinition<typeof rpcDefinition>;
